// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"f54c019f","346":"841a04a5","368":"03ef9109","488":"ec845d38","504":"7c136f8c","522":"b87f4701","670":"ccf9ee4a","768":"39c0d272","796":"23a14e0c","832":"bff32cb4","849":"0f0a3f24","856":"aa80ce5d"}[chunkId] + ".chunk.js";
};